import React, { useContext, useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim"; 
import { ThemeContext } from '../Darktheme/ThemeContext';
import { Helmet } from "react-helmet"; 
const ParticlesComponent = (props) => {
  const { darkMode } = useContext(ThemeContext);
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = (container) => {
    console.log(container);
  };

  const options = useMemo(
    () => ({
      background: {
        color: {
          value: darkMode ? "#000000" : "#FFFFFF", // Adjust background color based on darkMode
        },
      },

      fullScreen :{
        "enable":false,
        "zIndex":-1
      },

      fpsLimit: 120,
      interactivity: {
        events: {
          onClick: {
            enable: true,
            mode: "push",
          },
          onHover: {
            enable: true,
            mode: "grab",
          },
        },
        modes: {
          push: {
            distance: 200,
            duration: 15,
          },
          grab: {
            distance: 150,
          },
        },
      },
      particles: {
        color: {
          value: darkMode ? "#FFFFFF" : "rgb(255, 0, 0);", // Adjust particle color based on darkMode
          
        },
        links: {
          color: darkMode ? "#FFFFFF" : "rgb(255, 0, 0);", // Adjust link color based on darkMode

          distance: 150,
          enable: true,
          opacity: 0.3,
          width: 1,
        },
        move: {
          direction: "none",
          enable: true,
          outModes: {
            default: "bounce",
          },
          random: true,
          speed: 4,
          straight: false,
        },
        number: {
          density: {
            enable: true,
          },
          value: 250,
        },
        opacity: {
          value: 1.0,
        },
        shape: {
          type: "circle",
        },
        size: {
          value: { min: 1, max: 3 },
        },
      },
      detectRetina: true,
    }),
    [darkMode], // Recompute the options whenever darkMode changes
  );

  return (
    <>
      <Helmet>
        <title>Particles Background | Tinu Kumar's Portfolio</title>
        <meta name="description" content="Explore the interactive particle background in Tinu Kumar's portfolio. Experience a dynamic visual display." />
        <meta name="keywords" content="Tinu Kumar, Particles Background, Web Developer, Portfolio" />
      </Helmet>
      <Particles id={props.id} init={particlesLoaded} options={options} />
    </>
  );
};

export default ParticlesComponent;



